var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPauseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 4.46 15.54 0 10 0C8.83 0 7.7 0.19 6.62 0.56L7.32 2.5C8.17 2.16 9.06 1.97 10 1.97C14.41 1.97 18.03 5.59 18.03 10C18.03 14.41 14.41 18.03 10 18.03C5.59 18.03 1.97 14.41 1.97 10C1.97 9.06 2.16 8.12 2.5 7.28L0.56 6.62C0.19 7.7 0 8.83 0 10C0 15.54 4.46 20 10 20C15.54 20 20 15.54 20 10ZM3.47 5C2.68 5 1.97 4.32 1.97 3.47C1.97 2.68 2.68 1.97 3.47 1.97C4.32 1.97 5 2.68 5 3.47C5 4.32 4.32 5 3.47 5ZM7 7H9V13H7V7ZM11 7H13V13H11",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/PauseIcon.fc26806c.svg";
export { ForwardRef as ReactComponent };